<template>
  <a-card :bordered="false">
    <a-form class="m-form" :form="form">
      <a-row type="flex" justify="start" align="top" :gutter="16">
        <a-col :xs="{span: 24}" :lg="{span:12}">
          <a-form-item label="Jenis Kegiatan">
            <a-select show-search :filter-option="filterOption" allowClear v-decorator="['jenis_kegiatan', {rules: [{required: true, message: 'Harus diisi!'}]}]">
              <a-select-option key="Magang">Magang</a-select-option>
              <a-select-option key="Praktek Kerja Lapangan">Praktek Kerja Lapangan</a-select-option>
              <a-select-option key="Praktek Kerja">Praktek Kerja</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Unit Kegiatan">
            <a-select show-search :filter-option="filterOption" allowClear
              v-decorator="['unit_kegiatan', {rules: [{required: true, message: 'Harus diisi!'}]}]"
              @change="changeUnit"
            >
              <a-select-option
                v-for="items in datamaster.divisi"
                :key="items.divisi"
              >{{items.divisi}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="{span: 24}" :lg="{span:12}">
          <a-form-item label="Pembimbing">
            <a-select show-search :filter-option="filterOption" allowClear v-decorator="['pembimbing', {rules: [{required: true, message: 'Harus diisi!'}]}]">
              <a-select-option
                v-for="items in listpembimbing"
                :key="items.tlc"
              >{{items.nama}} [{{items.tlc}}]</a-select-option>
            </a-select>
          </a-form-item>
          <a-row type="flex" justify="start" align="top" :gutter="16">
            <a-col :xs="{span: 24}" :lg="{span:12}">
              <a-form-item label="Tanggal Mulai">
                <a-date-picker
                  class="w-full"
                  :format="getDefaultDateFormat"
                  v-decorator="['tglmasuk', {rules: [{required: true, message: 'Harus diisi!'}]}]"
                />
              </a-form-item>
            </a-col>
            <a-col :xs="{span: 24}" :lg="{span:12}">
              <a-form-item label="Tanggal Selesai">
                <a-date-picker
                  class="w-full"
                  :format="getDefaultDateFormat"
                  v-decorator="['tglselesai', {rules: [{required: true, message: 'Harus diisi!'}]}]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <!-- <a-row type="flex" justify="end" align="top" :gutter="16">
            <a-col :xs="{span: 24}" :lg="{span:24}">
              <a-form-item label="">
                <a-checkbox
                  v-decorator="[ 'istruth', { rules: [{required: true, message: 'Harus diisi!'}], valuePropName: 'checked',
                  initialValue: initial.istruth == '1' ? true : null, }, ]"
                  class="m-top"
                  @change="ChangeIsTruth"
                >
                  <span style="color:red">* </span>Data yang telah diinput dinyatakan benar
                </a-checkbox>
              </a-form-item>
            </a-col>
          </a-row> -->
        </a-col>
      </a-row>
    </a-form>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "employee",
  props: ["collectedData", "mode", "datamaster"],
  data() {
    return {
      isfungsional:true,
      listpembimbing: []
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.$store.dispatch("Fetch_Bank");
  },
  computed: {
    ...mapGetters(["getMaster", "getBank", "getDefaultDateFormat"]),
    initial() {
      let initialData = {};
      if (this.collectedData.kegiatan!=null) {
        initialData = {
          istruth: this.collectedData.kegiatan.istruth,
        };
      }
      return initialData;
    }
  },
  methods: {
    handleFilterJabatan(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        // let posisiNm = _.filter(this.getMaster.posisi,filt =>
        //     filt.id_jabatan==values.posisi
        // );
        // values.nama_jabatan = posisiNm[0].nama_jabatan;
        Event.$emit("createKaryawan", values);
      });
    },
    changeCareer_path(e){
      this.isfungsional = e=="Struktural" ? false : true;
    },
    ChangeIsTruth(val){
      if(!val.target.checked){
        this.$nextTick(() => {
          this.form.setFieldsValue({
            istruth: null,
          });
        })
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    changeUnit(val){
      
      this.$nextTick(() => {
        this.form.setFieldsValue({
          pembimbing: null,
        });
      })
      this.listpembimbing = this.datamaster.pembimbing.filter((item)=>{
        return item.divisi==val
      })
    }
  },
};
</script>

<style>
</style>